<template>
  <FilterBase label="Collection" class="pb-4">
    <ValueSelect
      :value="collection"
      :options="collections"
      show-clear-button
      placeholder="Select a collection"
      label="Collections"
      :announced-field-cleared="false"
      :hide-messages="true"
      @value-selected="collectionSelected"
    />
  </FilterBase>
</template>

<script>
import FilterBase from "~/components/communities/components/FilterBase.vue";
import ValueSelect from "~/components/combobox/ValueSelect";

export default {
  name: "CollectionSelection",
  components: {
    FilterBase,
    ValueSelect,
  },
  props: {
    collections: { type: Array, default: () => [] },
    collection: { type: Object, default: () => undefined },
  },
  methods: {
    collectionSelected(collection) {
      this.$emit("collection-selected", collection);
    },
  },
};
</script>
